import type { PipelineContext } from '../../../core/types';
import { resolveEnabledModulesForSpecFilter } from '../../_shared/common/sku/resolveEnabledModulesForSpecFilter';
import { hydrateApplicationInstanceDetailToForm } from '../hydrateFromApiDetail';
import { filterAppInstanceSpecByEnabledModules } from './enabledModules';
import { formToPayload } from './payload';
import type { AppInstanceSpec } from './schema';

export function appInstanceFromForm(values: Record<string, unknown>, ctx: PipelineContext): AppInstanceSpec {
  const spec = formToPayload(values as Parameters<typeof formToPayload>[0]);
  const enabledModules = resolveEnabledModulesForSpecFilter(ctx, values);
  return filterAppInstanceSpecByEnabledModules(spec, enabledModules, ctx.sku?.skuType);
}

/** spec → 扁平表单（SKU preset 回填 / 展示辅助） */
export function appInstanceToForm(spec: AppInstanceSpec, _ctx?: PipelineContext): Record<string, unknown> {
  const workload = { spec, metadata: { name: '', namespace: '' } };
  return hydrateApplicationInstanceDetailToForm(workload) as Record<string, unknown>;
}

export function appInstanceGetInitialFormValues(_ctx?: PipelineContext): Record<string, unknown> {
  return {};
}
